import type { MemberOverwrite, PermissionOverwrite } from "./permissions";

/** The permission settings a category shares with its synced channels. */
export interface PermissionTemplate {
  isPrivate: boolean;
  allowedRoleIds: string[];
  overwrites: PermissionOverwrite[];
  memberOverwrites: MemberOverwrite[];
}

const key = (t: PermissionTemplate) =>
  JSON.stringify([
    t.isPrivate,
    // The role list only matters while the channel is private.
    t.isPrivate ? [...new Set(t.allowedRoleIds)].sort() : [],
    t.overwrites
      .filter((o) => o.allow || o.deny)
      .map((o) => `${o.roleId}:${o.allow}:${o.deny}`)
      .sort(),
    t.memberOverwrites
      .filter((o) => o.allow || o.deny)
      .map((o) => `${o.userId}:${o.allow}:${o.deny}`)
      .sort(),
  ]);

/** Whether two permission setups are the same, ignoring order and empty overrides (Discord's "synced"). */
export function samePermissions(a: PermissionTemplate, b: PermissionTemplate) {
  return key(a) === key(b);
}
